// src/pages/TrashModuleTable.jsx
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import { FiRotateCw, FiTrash2, FiEdit3 } from "react-icons/fi";
import Table from "../shared/table/Table";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

import { confirmAlert } from "react-confirm-alert"; 
import { toast } from "react-toastify"; 


const TrashModuleTable = () => {
  const [modules, setModules] = useState([]);
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const getText = (key, def = "") => translations[key] || def;

  const fetchTrash = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/modules/trash/module`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModules(res.data);
    } catch (err) {

    }
  };

  useEffect(() => {
    fetchTrash();
  }, []);

  const handleRestore = (id) => {
    confirmAlert({
      title: getText("RESTORE_CONFIRM_TITLE", "Modülü Geri Yükle"),
      message: getText("RESTORE_CONFIRM_MSG", "Bu modülü geri yüklemek istediğinize emin misiniz?"),
      buttons: [
        {
          label: getText("YES_RESTORE", "Evet, Geri Yükle"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/modules/${id}/restore`, {}, {
                headers: { Authorization: `Bearer ${token}` }
              });
              toast.success(getText("SUCCESS_MODULE_RESTORED", "Modül başarıyla geri yüklendi!"));
              fetchTrash();
            } catch (err) {
              console.error("Geri yükleme hatası:", err);
              toast.error(getText("ERROR_MODULE_RESTORE_FAILED", "Geri yükleme başarısız!"));
            }
          },
        },
        {
          label: getText("CANCEL", "İptal"),
          onClick: () => toast.info(getText("RESTORE_CANCELLED", "İşlem iptal edildi.")),
        },
      ],
    });
  };
  
  const handlePermanentDelete = (id) => {
    confirmAlert({
      title: getText("DELETE_CONFIRM_TITLE", "Modülü Kalıcı Sil"),
      message: getText("DELETE_CONFIRM_MSG", "Bu modülü kalıcı olarak silmek istediğinize emin misiniz?"),
      buttons: [
        {
          label: getText("YES_DELETE", "Evet, Sil"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/modules/${id}/permanent`, {
                headers: { Authorization: `Bearer ${token}` }
              });
              toast.success(getText("SUCCESS_MODULE_DELETED", "Modül kalıcı olarak silindi!"));
              fetchTrash();
            } catch (err) {
              console.error("Kalıcı silme hatası:", err);
              toast.error(getText("ERROR_MODULE_DELETE_FAILED", "Kalıcı silme başarısız!"));
            }
          },
        },
        {
          label: getText("CANCEL", "İptal"),
          onClick: () => toast.info(getText("DELETE_CANCELLED", "İşlem iptal edildi.")),
        },
      ],
    });
  };

  const columns = useMemo(() => [
    { accessorKey: "id", header: getText("TABLE_ID_LABEL", "ID"), size: 60 },
    { accessorKey: "name", header: getText("TABLE_MODULE_NAME_LABEL", "Modül Adı"), size: 200 },
    {
      accessorKey: "created_at",
      header: getText("TABLE_CREATED_AT", "Oluşturulma Tarihi"),
      cell: info => new Date(info.getValue()).toLocaleDateString("tr-TR"),
      size: 160
    },
    {
      accessorKey: "deleted_at",
      header: getText("TABLE_DELETED_AT", "Silinme Tarihi"),
      cell: info => new Date(info.getValue()).toLocaleDateString("tr-TR"),
      size: 160
    },
    {
      accessorKey: "actions",
      header: getText("TABLE_ACTIONS_LABEL", "İşlemler"),
      enableSorting: false,
      size: 180,
      cell: info => {
        const id = info.row.original.id;
        const slug = info.row.original.multiple_slug;

        return (
          <div className="d-flex gap-2 justify-content-end">
             
             <Link
                to={`/admin/modules/edit/${slug}`}
                className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                title={getText("EDIT", "Düzenle")}
                >
                <FiEdit3 />
                </Link>

                        
            <button
              title="Geri Yükle"
              className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
              onClick={() => handleRestore(id)}
            >
              <FiRotateCw />
            </button>
            <button
              title="Kalıcı Sil"
              className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
              onClick={() => handlePermanentDelete(id)}
            >
              <FiTrash2 />
            </button>
          </div>
        );
      }
    }
  ], [getText]);

  return <Table data={modules} columns={columns} />;
};

export default TrashModuleTable;
